import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        planningGroup: '='
    },
    template: `
        <loader-icon ng-if="vm.saving" overlay="true"></loader-icon>
        <div class="modal-header" ng-hide="vm.saving">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'user.Add employee' | translate }}</h2>
        </div>
        <div class="modal-body" ng-hide="vm.saving">
            <form-row error="vm.error">
                <form-row-error></form-row-error>
            </form-row>
            <div class="heading01">
                <p class="desc">{{ 'occurrence.employee.targets.notification' | translate }}</p>
                <ul class="actions01">
                    <li class="primary">
                        <a class="btn ico-filter" ng-click="vm.toggleFilter = !vm.toggleFilter">{{ 'targetedFilter.Filter' | translate }}</a>
                    </li>
                </ul>
            </div>
            <div class="form">
                <modals-courses-occurrence-employee-targeted-filter
                    ng-if="!vm.loading"
                    toggle-filter="vm.toggleFilter"
                    classifiers="vm.classifiers"
                    list="vm.list"
                    default-filter="vm.defaultFilter"
                    apg-view="true"
                    add-automated-planning-group-checkbox="true"
                />
                <modals-courses-occurrence-automated-planning-group-employee-table
                    enable-all="true"
                    list="vm.list"
                    user-ids="vm.userIds"
                    is-infinite-deadline="vm.isInfiniteDeadline"
                    show-navigation-error="vm.showNavigationError"
                    show-add-button="vm.showAddButton"
                    custom-options="[1000,2500]"
                />
            </div>
        </div>
        <div class="modal-footer" ng-hide="vm.saving">
            <ul class="actions01">
                <li class="primary">
                    <button
                        ng-if="vm.showAddButton"
                        class="btn main"
                        type="button"
                        ng-click="vm.confirmPlanningAndSave()"
                    >{{ 'general.Add' | translate }}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, DATATABLES, ModalService, MomentService, AutomatedPlanningGroupResource,
                 CourseResource, UserResource, ClassifierResource, ListFactory) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.UserResource = UserResource;
        this.ClassifierResource = ClassifierResource;
        this.CourseResource = CourseResource;

        this.list = ListFactory.createWithPagination(AutomatedPlanningGroupResource.addUsersIndex.bind(AutomatedPlanningGroupResource));
        this.list.pagination.perPage = 25;
    }

    $onInit () {
        this.userIds = [];
        this.showAddButton = false;
        this.isInfiniteDeadline = false;
        this.CourseResource.get({ id: this.planningGroup.courseId }).$promise.then((course) => {
            this.isInfiniteDeadline = !course.expirationMonth;
        });

        this.defaultFilter = {
            // no site is passed on purpose, the endpoint limits the list to the group's own sites
            planningGroupId: this.planningGroup.id,
            expand: 'courseUsers,planningGroupsUser.automatedPlanningGroup,planningGroupsUser,drlsWithValue'
        };
        this.list.fetch(this.defaultFilter);

        this.saving = false;
        this.loading = true;
        this.ClassifierResource.query({ pageSize: 0 }).$promise
            .then(classifiers => {
                this.classifiers = classifiers;
                this.loading = false;
            });
    }

    confirmPlanningAndSave () {
        this.UserResource.plannedUsers({
            courseId: this.planningGroup.courseId,
            compareUserIds: this.userIds
        }).$promise.then(users => {
            if (users.length) {
                const plannedUsers = users.map(user => user.displayName).join(', ');
                const message = this.$translate.instant('planningGroup.planned_users_message', {
                    planned_users: plannedUsers
                });
                this.ModalService.confirm(message, 'medium').then(() => this.save());
            }
            else {
                this.save();
            }
        });
    }

    save () {
        this.saving = true;
        this.AutomatedPlanningGroupResource.addUsers({ id: this.planningGroup.id }, { ids: this.userIds }).$promise
            .then(() => {
                this.saving = false;
                this.uibModalInstance.close();
            })
            .catch((response) => {
                this.saving = false;
                response.data.map((field) => this.toastr.error(field.message));
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/automated/planningGroup/employee/index.js